import { DetailsNonGCFData } from "../../../types"
import LineChart from "./LineChart"

type LineChartContainerProps = {
  width: number
  height: number
  item: { key: string; value: DetailsNonGCFData[] }
  bottomTitles: string[]
  netKeys: string[]
  oibiaKeys: string[]
  availableEntities: string[][]
  dataType: string
  entityIndex: number
  showOI: boolean
  showRevenue: boolean
}

export function LineChartLayout({
  width,
  height,
  item,
  bottomTitles,
  netKeys,
  oibiaKeys,
  availableEntities,
  dataType,
  entityIndex,
  showOI,
  showRevenue,
}: LineChartContainerProps) {
  const revenueValues = item.value.map(
    (
      row: { [x: string]: string | number | null; entityName: string },
      index: number,
    ) => {
      return netKeys.map((key, ind) => {
        return {
          key: key,
          entity: row.entityName,
          title: bottomTitles[ind],
          value: row[key as keyof typeof row] as number,
          itemIndex: index,
        }
      })
    },
  )

  const oibiaValues = item.value.map(
    (row: { [x: string]: string | number | null; entityName: string }) => {
      return oibiaKeys.map((key, ind) => {
        return {
          key: oibiaKeys[ind],
          entity: row.entityName,
          title: bottomTitles[ind],
          value: row[key as keyof typeof row] as number,
        }
      })
    },
  )

  return (
    <LineChart
      width={width}
      height={height}
      revenueData={revenueValues}
      oibiaData={oibiaValues}
      keys={netKeys}
      bottomTitles={bottomTitles}
      availableEntities={availableEntities}
      dataType={dataType}
      entityIndex={entityIndex}
      showOI={showOI}
      showRevenue={showRevenue}
      entity={item.key}
    />
  )
}
